import type { AvatarStateSpec } from '../types/anna';

export const avatarStates: AvatarStateSpec[] = [
  {
    id: 'rust',
    label: 'Rust',
    motion: 'Trage ademhaling in een cyclus van 5 s. Deeltjes drijven zacht, met korte lichtfilamenten.',
    sound: 'Stil',
    caption: 'Rustig in huis. 2 dingen wachten op je, niets dringends.',
  },
  {
    id: 'luistert',
    label: 'Luistert',
    motion: 'Het veld opent zich. De ring volgt je stemvolume live.',
    sound: 'Korte stijgende toon bij wekken',
    soundId: 'klaar',
    caption: 'Ik luister.',
  },
  {
    id: 'denkt',
    label: 'Denkt',
    motion: 'Deeltjes trekken samen en draaien sneller om de kern, met een zachte glinstering. Maximaal ~1 s.',
    sound: 'Stil',
    caption: 'Even kijken…',
  },
  {
    id: 'spreekt',
    label: 'Spreekt',
    motion: 'De kern pulseert mee met de spraak. Ondertitel eronder, woord voor woord.',
    sound: 'Anna’s stem',
    caption: 'Goedemorgen. Je eerste afspraak is om 10:00. Ik heb vannacht de build van project X gerepareerd.',
  },
  {
    id: 'werkt',
    label: 'Werkt op de achtergrond',
    motion: 'Dunne draden in een baan, één per actieve agent, in de agentkleur. De snelheid volgt de voortgang van die taak.',
    sound: 'Stil',
    caption: 'Code, Mail en Studio zijn bezig.',
  },
  {
    id: 'meldt',
    label: 'Meldt iets',
    motion: 'Eén zachte golf naar buiten. Wordt niet herhaald.',
    sound: 'Eén zachte chime',
    soundId: 'meldt',
    caption: 'Je meeting met Lisa begint om 14:00.',
  },
  {
    id: 'nietStoren',
    label: 'Niet storen',
    motion: 'Gedimd en samengetrokken tot een klein warm amberpunt. Geen pieken in beweging.',
    sound: 'Gedempt',
    caption: 'Focus. Ik meld alleen wat dringend is.',
  },
  {
    id: 'bezorgd',
    label: 'Bezorgd',
    motion: 'De kern verschuift naar warm, met een langzame puls. Nooit knipperend rood, behalve bij echte veiligheidsalarmen.',
    sound: 'Lage toon bij geweigerd',
    soundId: 'geweigerd',
    caption: 'De cloudkosten zitten op 80% van je budget.',
  },
  {
    id: 'gestopt',
    label: 'Gestopt',
    motion: 'Het veld klapt in tot een stille grijze stip. Geen beweging.',
    sound: 'Stil',
    caption: 'Noodstop actief. Ik doe niets tot je me hervat.',
  },
];
